<template>
  <v-card class="pa-3" outlined style="border-radius: 6px; height: 100%">
    <div class="pa-2 grey lighten-2" style="border-radius: 6px">
      <strong>{{ $t('Equipamento Parado x Tipo de Pendência') }}</strong>
    </div>

    <div class="pa-4 d-flex justify-center" v-if="data.objects.length == 0">
      <strong>{{ $t('Nenhum registro encontrado') }}</strong>
    </div>

    <v-simple-table class="main-table" dense v-if="data.objects.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">{{ $t('Número OS') }}</th>
            <th class="text-left">{{ $t('Equipamento') }}</th>
            <th class="text-left">{{ $t('Setor') }}</th>
            <th class="text-left">{{ $t('Data solicitação') }}</th>
            <th class="text-left">{{ $t('Tipo pendência') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data.objects" :key="item.identification">
            <td></td>
            <td>{{ item.osNumber }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.sector }}</td>
            <td>{{ formatDate(item.solicitation) }}</td>
            <td>{{ $t(item.service) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pagination">
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'EquipStoppedComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
    institutionIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    institutionIds() {
      this.filter.institutionIds = this.institutionIds
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      apiService: new ApiService(),
      filter: {
        page: 1,
        pageSize: 5,
        unidadeIds: [],
        departmentIds: [],
        institutionIds: [],
        institutionId: 1,
      },
      data: {
        objects: [],
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/yyyy hh:mm')
      } else return 'Sem registro'
    },
    list() {
      this.apiService
        .post('dash/equip-stopped', this.filter)
        .then((response) => {
          this.data = response.content
          this.totalPages = response.content.pager.totalPages
        })
    },
  },
}
</script>

<style scoped></style>
